"use client";

import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Brain } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function BehavioralSupport() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section className="relative w-full bg-dark-background py-20 overflow-hidden">
      <div className="absolute inset-0 opacity-5 pointer-events-none" style={{
      backgroundImage: `repeating-linear-gradient(
            45deg,
            transparent,
            transparent 2px,
            rgba(255,255,255,0.03) 2px,
            rgba(255,255,255,0.03) 4px
          )`
    }} />
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-4xl">
        <div ref={ref} className={`transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
          <Card className="relative bg-background/80 backdrop-blur-md border border-border/50 shadow-medium hover:shadow-strong hover:-translate-y-1 hover:scale-[1.02] transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] overflow-hidden rounded-lg">
            <CardContent className="flex flex-col items-center text-center p-8 sm:p-12 gap-6">
              <div className="flex items-center justify-center w-20 h-20 rounded-full bg-primary text-white">
                <Brain className="w-12 h-12" />
              </div>

              <h2 className="text-3xl sm:text-4xl font-display font-bold text-foreground">
                Behavioral Support
              </h2>

              <p className="text-base sm:text-lg text-foreground max-w-2xl leading-relaxed">
                Our specialized behavioral support services leverage advanced
                technology and AI-driven insights to help students with diverse
                learning needs develop essential social-emotional skills and
                self-regulation strategies in supportive, inclusive
                environments.
              </p>

              <Link to="#" className="mt-4">
                <Button size="lg" className="bg-action text-foreground hover:bg-action-hover hover:scale-[1.02] hover:shadow-medium hover:-translate-y-0.5 transition-all duration-[var(--duration-fast)] ease-[var(--ease-spring)] rounded-md">
                  Learn More About Our Services
                </Button>
              </Link>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>;
}